import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosDummyInstance, axiosScraper } from '@utils/axios/axiosInstance';
import { addDelKeywordParamsType } from '@models/keyword/keywordModel';
import { tabDataParamsType } from '../keywordSuggestionSlice';
import { keywordScoreFormulaBase } from '@utils/common/keywordScoreFormula';

// 여기선 tab요소가 있어 공통으로 사용안되므로 아래처럼 union 처리를 함
export type keywordAddDelType = {
  tabIndex: number;
  keywordObj: any; // TODO: 추후 객체 타입 정해지면 정의하기
  userId: string;
  reqTrackedType: string; //DB에 요청 처리 (add/del 구분 add,del)
};
// & addDelKeywordParamsType;

type reqTabKeywordParamsType = {
  userId: string;
  tabText: string;
};

type reqRegisteredDelAllType = {
  userId: string;
  keywordList: string[];
};

//// tab request param type ////
// AppleAutoFill (aso suggest func only ios)
// GooglePlaySuggestion (aso suggest func only playstore)
type reqSuggestParamsType = {
  provider_type: string;
  keywords: string[];
  country: string;
  lang: string;
  // baseType: "keyword"  추가로 보내야함.
};
// similarKeywords (aso similar func either ios or playstore)
type reqSimilarParamsType = {
  provider_type: string;
  appId: string;
  country: string;
  lang: string;
};

// ResearchRegisteredGridData 요청
export const fetchRegisteredData = createAsyncThunk('fetchRegisteredData', async (params: { email: string }) => {
  try {
    const { data, status } = await axiosDummyInstance.get('/api/keyword/researchRegisteredData.json', { params });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    console.log('fetchRegisteredDataError: ', error);
  }
});

//ResearchTabGridData 요청
export const fetchTabGridData = createAsyncThunk('fetchTabGridData', async (params: tabDataParamsType) => {
  try {
    const { data, status } = await axiosDummyInstance.get('/api/keyword/researchTabData.json', { params });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    console.log('fetchTabGridDataError: ', error);
  }
});

// TODO: 아래의 탭별 fetch 따로 만들기!@!
// 응답 후 요청 index 를 parameter로 주입받아 tabInfoData 에 해당 데이터 넣기
// index 가 6개이므로 전부 만들어야 한다.
// apple auto fill tab
export const fetchAppleAutoFillData = createAsyncThunk(
  'fetchAppleAutoFillData',
  async (params: reqSuggestParamsType) => {
    try {
      // 애플일때만 데이터 요청하기
      if (params.provider_type === 'apple') {
        const { data, status } = await axiosScraper.post('/axo/asoSuggest', {
          ...params,
          baseType: 'keyword',
        });
        // 데이터가 없다면 빈배열 넘기기
        console.log('AppleAutoFill status: ', status);
        console.log('AppleAutoFill data: ', data);
        if (status === 200 && !!data) {
          // null 인 데이터는 거르기
          return data
            .filter((item) => item !== null)
            .map((item) => {
              return {
                keyword: item.keyword,
                searchScore: keywordScoreFormulaBase.searchScore(item.keywordScore.traffic.score),
                diff: keywordScoreFormulaBase.diffScore(item.keywordScore.difficulty.score),
                chance: keywordScoreFormulaBase.chanceScore(item.keywordScore.difficulty.score),
                // // 아래의 두 항목은 slice 에서 처리하기
                // tracked: objIndex > -1 ? true : false,
                // group: objIndex > -1 ? registeredKeywordList[objIndex].group ?? null : null,
              };
            });
        } else {
          return [];
        }
      } else {
        return [];
      }
    } catch (error) {
      console.log('fetchAppleAutoFillData Error: ', error);
    }
  }
);
// google play suggestion tab
export const fetchGooglePlaySuggestionData = createAsyncThunk(
  'fetchGooglePlaySuggestionData',
  async (params: reqSuggestParamsType) => {
    try {
      // 구글일때만 데이터 요청하기
      if (params.provider_type === 'google') {
        const { data, status } = await axiosScraper.post('/axo/asoSuggest', {
          ...params,
          baseType: 'keyword',
        });
        console.log('GooglePlayStore status: ', status);
        console.log('GooglePlayStore data: ', data);
        if (status === 200 && !!data) {
          // null 인 데이터는 거르기
          return data
            .filter((item) => item !== null)
            .map((item) => {
              return {
                keyword: item.keyword,
                searchScore: keywordScoreFormulaBase.searchScore(item.keywordScore.traffic.score),
                diff: keywordScoreFormulaBase.diffScore(item.keywordScore.difficulty.score),
                chance: keywordScoreFormulaBase.chanceScore(item.keywordScore.difficulty.score),
                // // 아래의 두 항목은 slice 에서 처리하기
                // tracked: objIndex > -1 ? true : false,
                // group: objIndex > -1 ? registeredKeywordList[objIndex].group ?? null : null,
              };
            });
        } else {
          return [];
        }
      } else {
        return [];
      }
    } catch (error) {
      console.log('fetchGooglePlaySuggestionData Error: ', error);
    }
  }
);
// searchAds recommended tab TODO: 아직 안정해짐.. 일단 settime걸기
export const fetchSearchAdsRecommendedData = createAsyncThunk('fetchSearchAdsRecommendedData', async (params) => {
  try {
    // return new Promise(() => {
    //   setTimeout(() => [], 3000);
    // }).then(res => res).catch(err => console.log(err));
    return [];
  } catch (error) {
    console.log('fetchSearchAdsRecommendedData Error: ', error);
  }
});
// similar keyword tab
export const fetchSimilarKeywordData = createAsyncThunk(
  'fetchSimilarKeywordData',
  async (params: reqSimilarParamsType) => {
    try {
      const { data, status } = await axiosScraper.post('/axo/asoSimilar', params);
      if (status === 200 && !!data) {
        // null 인 데이터는 거르기
        return data
          .filter((item) => item !== null)
          .map((item) => {
            return {
              keyword: item.keyword,
              searchScore: keywordScoreFormulaBase.searchScore(item.keywordScore.traffic.score),
              diff: keywordScoreFormulaBase.diffScore(item.keywordScore.difficulty.score),
              chance: keywordScoreFormulaBase.chanceScore(item.keywordScore.difficulty.score),
              // // 아래의 두 항목은 slice 에서 처리하기
              // tracked: objIndex > -1 ? true : false,
              // group: objIndex > -1 ? registeredKeywordList[objIndex].group ?? null : null,
            };
          });
      } else {
        return [];
      }
    } catch (error) {
      console.log('fetchSimilarKeywordData Error: ', error);
    }
  }
);
// related keyword tab
export const fetchRelatedKeywordData = createAsyncThunk('fetchRelatedKeywordData', async (params) => {
  try {
    // return new Promise(() => {
    //   setTimeout(() => [], 3000);
    // }).then(res => res).catch(err => console.log(err));
    return [];
  } catch (error) {
    console.log('fetchRelatedKeywordData Error: ', error);
  }
});
// Trending Searches tab
export const fetchTrendingKeywordData = createAsyncThunk('fetchTrendingKeywordData', async (params) => {
  try {
    // return new Promise(() => {
    //   setTimeout(() => [], 3000);
    // }).then(res => res).catch(err => console.log(err));
    return [];
  } catch (error) {
    console.log('fetchTrendingKeywordData Error: ', error);
  }
});

// tabkeywordGridData 요청
export const fetchTabKeywordGridData = createAsyncThunk(
  'fetchTabKeywordGridData',
  async (params: reqTabKeywordParamsType) => {
    try {
      const { userId, tabText } = params;
      let reqApi;
      switch (tabText) {
        case 'Apple Auto Fill':
          reqApi = '/api/keyword/researchTabKeyword1.json';
          break;
        case 'Google Play Suggestions':
          reqApi = '/api/keyword/researchTabKeyword2.json';
          break;
        case 'SearchAds Recommended Keywords':
          reqApi = '/api/keyword/researchTabKeyword3.json';
          break;
        case 'Similar Keywords':
          reqApi = '/api/keyword/researchTabKeyword4.json';
          break;
        case 'Related keywords':
          reqApi = '/api/keyword/researchTabKeyword5.json';
          break;
        case 'Trending Searches':
          reqApi = '/api/keyword/researchTabKeyword6.json';
          break;
        default:
          break;
      }
      const { data, status } = await axiosDummyInstance.get(reqApi, { params });
      if (status === 200) {
        return data;
      }
    } catch (error) {
      console.log('fetchTabKeywordGridDataError: ', error);
    }
  }
);

//addDelRequestKeyword 요청
export const fetchKeywordAddDel = createAsyncThunk('fetchKeywordAddDel_research', async (params: keywordAddDelType) => {
  try {
    console.log('fetchKeywordAddDel params: ', params);
    //TODO: 추후 POST 요청으로 변경처리할 것
    const { data, status } = await axiosDummyInstance('/api/commonGetResponse.json');
    if (status === 200) {
      // // TODO: 여기서 registerdData 한번 더 요청하기
      // const { data: registeredData, status: registeredStatus } = await axiosDummyInstance.get(
      //   '/api/keyword/researchRegisteredData.json',
      //   { params }
      // );
      // if (registeredStatus === 200) {
      //   console.log('registeredData111: ', registeredData);
      //   console.log('params111: ', params);
      //   return {
      //     registeredData,
      //     params,
      //   };
      // }

      return params;
    }
  } catch (error) {
    console.log('fetchKeywordAddDelError: ', error);
  }
});

// registeredkeywordList Delete 요청
export const fetchRegisteredKeywordDelete = createAsyncThunk(
  'fetchregisteredKeywordDelete',
  async (params: addDelKeywordParamsType) => {
    // TODO: 추후 REST API 에 맞춰 변경하기
    const { data, status } = await axiosDummyInstance('/api/commonGetResponse.json');
    if (status === 200) {
      return params;
    }
  }
);

// deleteAllRequestKeyword 요청
export const fetchKeywordDeleteAll = createAsyncThunk(
  'fetchKeywordDeleteAll_research',
  async (params: reqRegisteredDelAllType) => {
    // TODO 추후 백엔드 api 에 맞춰 변경할 것 params에 삭제할 keywordId string[] 으로 넘기기
    const { data, status, statusText } = await axiosDummyInstance('/api/commonGetResponse.json');
    if (status === 200) {
      return params.keywordList;
    }
  }
);
